<div class="modal-header file-viewer-header">
    <div class="file-viewer-heading">
        <span class="file-viewer-heading__icon">
            <lucide-icon [name]="fileType === 'img' ? 'image' : 'file-text'" [size]="19"></lucide-icon>
        </span>
        <div class="file-viewer-heading__copy">
            <h4 class="modal-title" [title]="file?.documentName">{{ file?.documentName }}</h4>
            <span class="file-viewer-subtitle">{{ 'COMMON.ACTIONS.PREVIEW' | translate }}</span>
        </div>
    </div>
    <div class="file-viewer-header-actions">
        <!-- Con texto visible y sin tooltip: en pantalla completa el navegador solo
             dibuja el modal y el tooltip (que vive en el body) no se vería -->
        <button type="button" class="file-viewer-fullscreen" (click)="toggleFullscreen()"
            [attr.aria-label]="(isFullscreen ? 'COMMON.ACTIONS.EXIT_FULL_SCREEN' : 'COMMON.ACTIONS.FULL_SCREEN') | translate">
            <lucide-icon [name]="isFullscreen ? 'minimize' : 'maximize'" [size]="16"></lucide-icon>
            <span>{{ (isFullscreen ? 'COMMON.ACTIONS.EXIT_FULL_SCREEN' : 'COMMON.ACTIONS.FULL_SCREEN') | translate }}</span>
        </button>
        <button type="button" class="close file-viewer-close" (click)="cancel()"
            [attr.aria-label]="'COMMON.BUTTONS.CLOSE' | translate">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
</div>

<div class="modal-body file-viewer-body">

    @if (hasError) {
        <div class="file-viewer-message file-viewer-message--error" role="alert">
            <lucide-icon name="circle-alert" [size]="18"></lucide-icon>
            <span>{{ 'COMMON.ACTIONS.FAIL_LOADING_OBJECT' | translate }}</span>
        </div>
    }
    @else if (!fileType) {
        <div class="file-viewer-loading">
            <div class="file-viewer-loading__label">
                <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                <span>{{ 'COMMON.ACTIONS.LOADING' | translate }}</span>
                <span class="file-viewer-loading__percent" *ngIf="loadingPercent !== null">{{ loadingPercent }}%</span>
            </div>
            <!-- Sin tamaño conocido la barra queda llena y animada (indeterminada) -->
            <ngb-progressbar class="file-viewer-progress" type="primary" height="8px"
                [value]="loadingPercent ?? 100" [striped]="loadingPercent === null" [animated]="loadingPercent === null"
                [attr.aria-label]="'COMMON.ACTIONS.LOADING' | translate"></ngb-progressbar>
        </div>
    }
    @else if (fileType === 'pdf') {
        <pdf-viewer [src]="url" [rotation]="0" [original-size]="false" [show-all]="true" [fit-to-page]="true"
            [zoom]="1" [zoom-scale]="'page-width'" [stick-to-page]="false" [render-text]="true"
            [external-link-target]="'blank'" [autoresize]="true" [show-borders]="false"
            class="file-viewer-frame"></pdf-viewer>
    }
    @else if (fileType === 'img') {
        <div class="file-viewer-center">
            <img [src]="url" class="file-viewer-image" [attr.alt]="file?.documentName" />
        </div>
    }
    @else if (fileType === 'video') {
        <div class="file-viewer-center">
            <video controls class="file-viewer-video">
                <source [src]="url" type="video/mp4" />
            </video>
        </div>
    }
    @else if (fileType === 'txt') {
        <pre class="file-viewer-text">{{ textFileContent }}</pre>
    }
    @else {
        <!-- html y documentos de Office -->
        @if (isDocument) {
            <div class="file-viewer-message">
                <lucide-icon name="info" [size]="18"></lucide-icon>
                <span>{{ 'BELIVPEDIA.MESSAGES.CANNOT_SEE_FILE' | translate }}</span>
            </div>
        }
        <iframe [src]="url" class="file-viewer-frame" frameborder="0" [attr.title]="file?.documentName"></iframe>
    }
</div>

<div class="modal-footer file-viewer-footer">
    <button type="button" class="btn btn-primary file-viewer-action" (click)="download()" [disabled]="!fileType" rippleEffect>
        <lucide-icon name="download" [size]="16"></lucide-icon>
        <span>{{ 'COMMON.ACTIONS.DOWNLOAD' | translate }}</span>
    </button>
    <button type="button" class="btn btn-outline-primary file-viewer-action" (click)="cancel()" rippleEffect>
        <lucide-icon name="x" [size]="16"></lucide-icon>
        <span>{{ 'COMMON.BUTTONS.CLOSE' | translate }}</span>
    </button>
</div>
